(() => {
  const initPrelaunch = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const controller = new AbortController();
    const signal = controller.signal;
    root.dataset.entryState = window.EDEntrance?.shouldShow(root) ? 'waiting' : 'entered';
    const renderer = window.EDLiquidGlass ? window.EDLiquidGlass.mount(root) : null;
    root.prelaunchController = controller;
    window.EDEntrance?.mount(root, renderer, signal);

    window.EDDesktop?.mount(root, signal);

    const newsletterForm = root.querySelector('.prelaunch__form');
    const submitButton = root.querySelector('.prelaunch__submit');
    if (newsletterForm && submitButton) {
      newsletterForm.addEventListener('submit', () => {
        if (!newsletterForm.checkValidity()) return;
        try { sessionStorage.setItem('ed-entrance-2.3', '1'); } catch (_) { /* Optional storage. */ }
        newsletterForm.classList.add('is-submitting');
        submitButton.setAttribute('aria-busy', 'true');
        window.EDLiquidGlass?.get(root)?.markSubmitting(submitButton);
      }, { signal });
    }

    if (renderer && root.querySelector('.prelaunch__glass-form.has-error')) {
      requestAnimationFrame(() => renderer.rippleFrom(root.querySelector('[data-glass-form]'), 0.72));
    }

    // The native Shopify form can return via the back-forward cache.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      newsletterForm?.classList.remove('is-submitting');
      submitButton?.removeAttribute('aria-busy');
    }, { signal });
  };

  const initAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-prelaunch]')) initPrelaunch(scope);
    scope.querySelectorAll('[data-prelaunch]').forEach(initPrelaunch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches('[data-prelaunch]')
      ? event.target
      : event.target.querySelector('[data-prelaunch]');
    if (!root) return;
    if (root.prelaunchController) root.prelaunchController.abort();
    const renderer = window.EDLiquidGlass ? window.EDLiquidGlass.get(root) : null;
    if (renderer) renderer.destroy();
  });
})();
